/* eslint-disable no-param-reassign */
import { SystemFuncArgs } from '@brochington/ecstatic';
import CarnivoreDoc from 'editor/components/CarnivoreDoc';
import { Components } from '../components';
import MoveBoxCPInteraction from '../components/interactions/MoveBoxCPInteraction';
import MoveLineCPInteraction from '../components/interactions/MoveLineCPInteraction';
import MoveMarkupInteraction from '../components/interactions/MoveMarkupInteraction';
import Tool, { EditorTools } from '../components/Tool';

export const configureToolComponents = [CarnivoreDoc, Tool];

export function configureTool(args: SystemFuncArgs<Components>): void {
  const { world, components } = args;
  const toolComp = components.get(Tool);
  const { doc } = components.get(CarnivoreDoc);

  if (toolComp.tool === EditorTools.Pointer) {
    const mbcpi = world.locate(MoveBoxCPInteraction);
    const mlcpi = world.locate(MoveLineCPInteraction);
    const mmi = world.locate(MoveMarkupInteraction);

    if (mbcpi || mlcpi || mmi) {
      if (doc.panEnabled()) {
        doc.disablePan();
      }
    } else if (!doc.panEnabled()) {
      doc.enablePan();
    }
  }

  if (
    [
      EditorTools.DrawRectangle,
      EditorTools.DrawLine,
      EditorTools.DrawArrow,
      EditorTools.DrawText,
      EditorTools.CreatePunch,
      EditorTools.PostRFI,
    ].some((t) => t === toolComp.tool)
  ) {
    if (doc.panEnabled()) {
      doc.disablePan();
    }
  }
}
